// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.a6oKV_Y1FJ9vIPeAFPpw {
  margin: 32px auto 0;
  width: 642px;
}

.nOTmlE4_4PMH2XSMD5Y4 {
  margin-top: 32px;
}

/* bootstrap xs breakpoint */
@media (max-width: 642px) {
  .a6oKV_Y1FJ9vIPeAFPpw {
      width: 100%;
      margin: 0;
      padding-top: 16px;
      background: white;
      height: 100%;
  }

  .a6oKV_Y1FJ9vIPeAFPpw h1 {
    margin: 0 0 0 16px;
  }

  .a6oKV_Y1FJ9vIPeAFPpw .card {
    padding: 16px;
    box-shadow: none;
  }

  .nOTmlE4_4PMH2XSMD5Y4 {
    margin-top: 16px;
  }

  .WlvmAUj7f7SFkIDAx_de {
    margin-bottom: 22px;
  }
}

.qcgkQi1CdSX5qr2rf_6B, .wF06iqRxkTkgEMTFnHh5 {
  margin: 0 16px;
  padding: 32px;
  color: white !important;
  box-shadow: 0px 2px 4px rgba(46, 50, 128, 0.2);
  border-radius: 4px;
}

.qcgkQi1CdSX5qr2rf_6B, .wF06iqRxkTkgEMTFnHh5 {
  background: #2EB6C8;
  border: 1px solid #29A2B3;
}

.JCPW7TY_ifDo7wYRmEDg {
  margin-bottom: -5px;
}

.qcgkQi1CdSX5qr2rf_6B h1, .wF06iqRxkTkgEMTFnHh5 h1 {
  font-weight: 800;
  color: white;
  margin-bottom: 10px;
}

.vs_NIuijLVyxVbTH80HJ {
  margin-top: 21px;
  font-weight: 600;
}

.Ml78wHWK1xoav_LDak3v {
  color: #777679;
}

.iVp4k1iztjviLVLjuPCb {
  background: #32445a;
  padding: 12px 14px;
  color: white;
  border-radius: 4px;
  font-size: 12px;
}

._fUZGAjkM9xaXQ1Y7_sq {
  font-size: 19px;
  line-height: 1.4em;
}`, "",{"version":3,"sources":["webpack://./src/pages/waitlist-update/update-form/components/update.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE;MACI,WAAW;MACX,SAAS;MACT,iBAAiB;MACjB,iBAAiB;MACjB,YAAY;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".container {\n  margin: 32px auto 0;\n  width: 642px;\n}\n\n.radioCardContainer {\n  margin-top: 32px;\n}\n\n/* bootstrap xs breakpoint */\n@media (max-width: 642px) {\n  .container {\n      width: 100%;\n      margin: 0;\n      padding-top: 16px;\n      background: white;\n      height: 100%;\n  }\n\n  .container h1 {\n    margin: 0 0 0 16px;\n  }\n\n  .container :global(.card) {\n    padding: 16px;\n    box-shadow: none;\n  }\n\n  .radioCardContainer {\n    margin-top: 16px;\n  }\n\n  .suggestedColumn {\n    margin-bottom: 22px;\n  }\n}\n\n.success, .info {\n  margin: 0 16px;\n  padding: 32px;\n  color: white !important;\n  box-shadow: 0px 2px 4px rgba(46, 50, 128, 0.2);\n  border-radius: 4px;\n}\n\n.success, .info {\n  background: #2EB6C8;\n  border: 1px solid #29A2B3;\n}\n\n.infoIcon {\n  margin-bottom: -5px;\n}\n\n.success h1, .info h1 {\n  font-weight: 800;\n  color: white;\n  margin-bottom: 10px;\n}\n\n.overviewDesc {\n  margin-top: 21px;\n  font-weight: 600;\n}\n\n.overviewValue {\n  color: #777679;\n}\n\n.signupMethodContext {\n  background: #32445a;\n  padding: 12px 14px;\n  color: white;\n  border-radius: 4px;\n  font-size: 12px;\n}\n\n.largePara {\n  font-size: 19px;\n  line-height: 1.4em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `a6oKV_Y1FJ9vIPeAFPpw`,
	"radioCardContainer": `nOTmlE4_4PMH2XSMD5Y4`,
	"suggestedColumn": `WlvmAUj7f7SFkIDAx_de`,
	"success": `qcgkQi1CdSX5qr2rf_6B`,
	"info": `wF06iqRxkTkgEMTFnHh5`,
	"infoIcon": `JCPW7TY_ifDo7wYRmEDg`,
	"overviewDesc": `vs_NIuijLVyxVbTH80HJ`,
	"overviewValue": `Ml78wHWK1xoav_LDak3v`,
	"signupMethodContext": `iVp4k1iztjviLVLjuPCb`,
	"largePara": `_fUZGAjkM9xaXQ1Y7_sq`
};
export default ___CSS_LOADER_EXPORT___;
